import AlfaSvg from '../../../../../assets/shapes/payments/Alfa.svg';
import SberSvg from '../../../../../assets/shapes/payments/Sber.svg';
import TinkoffSvg from '../../../../../assets/shapes/payments/Tinkoff.svg';
import VTBSvg from '../../../../../assets/shapes/payments/VTB.svg';
import RaiffaisenSvg from '../../../../../assets/shapes/payments/Raiffaisen.svg';
import OtkritieSvg from '../../../../../assets/shapes/payments/Otkritie.svg';

export const PAYMENT_SBP_MODAL_NAME = 'paymentSBP';

export const PAYMENT_SBP_ITEMS = [
  {
    icon: AlfaSvg,
    name: 'Альфа-Банк',
  },
  {
    icon: SberSvg,
    name: 'Сбербанк',
  },
  {
    icon: TinkoffSvg,
    name: 'Тинькофф',
  },
  {
    icon: VTBSvg,
    name: 'ВТБ',
  },
  {
    icon: RaiffaisenSvg,
    name: 'Райффайзенбанк',
  },
  {
    icon: OtkritieSvg,
    name: 'Открытие',
  },
];
